module.exports = __webpack_public_path__ + "assets/img/Type E (24).e61118ed.jpg";